import { render, staticRenderFns } from "./KnowledgeEditorMainTitle.vue?vue&type=template&id=bb373b34&scoped=true&"
import script from "./KnowledgeEditorMainTitle.vue?vue&type=script&lang=js&"
export * from "./KnowledgeEditorMainTitle.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeEditorMainTitle.vue?vue&type=style&index=0&id=bb373b34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb373b34",
  null
  
)

export default component.exports